import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { getBrowserCultureLang, Translation, TranslocoLoader } from '@jsverse/transloco';
import config, { AvailableLangs } from '../model/translaco.config';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoaderService implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }

  public static get defaultCultureLang(): AvailableLangs {
    const browserLanguage = this.getBrowserCultureLang()?.split(/[_-]/)[0];

    return browserLanguage && config.langs?.includes(browserLanguage)
      ? browserLanguage
      : config.defaultLang ?? 'en';
  }

  static readonly getBrowserCultureLang = getBrowserCultureLang;
}
